export function getAlternateGroupRowIds(rows) {
  const alternateRowIds = new Set();
  let previousGroupId;
  let alternate = false;

  rows.forEach((row, index) => {
    if (index > 0 && row.parent !== previousGroupId)
      alternate = !alternate;

    if (alternate)
      alternateRowIds.add(row.id);

    previousGroupId = row.parent;
  });

  return alternateRowIds;
}
